import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import AppMenuContent from '../../AppMenuContent';
import OptionsMenu from './OptionsMenu';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

function userEmail() {
  try {
    return typeof localStorage !== 'undefined' ? localStorage.getItem('Email') || '' : '';
  } catch {
    return '';
  }
}

function userRoleLabel(role, t) {
  if (!t || typeof t !== 'function') return role || '—';
  if (role === 'SUPER_ADMIN') return t('roles.superAdmin');
  if (role === 'ADMIN') return t('roles.admin');
  if (role === 'MERCHANT') return t('roles.merchant');
  if (role === 'OPERATOR') return t('roles.operator');
  if (role === 'TECHNICIAN') return t('roles.technician');
  return role || '—';
}

export default function SideMenu() {
  const { t } = useTranslation();
  const email = userEmail();
  const role = typeof localStorage !== 'undefined' ? localStorage.getItem('role') || '' : '';
  const roleLabel = userRoleLabel(role, t);
  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        direction="row"
        sx={{
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Avatar
          sizes="small"
          sx={{ width: 36, height: 36, bgcolor: 'primary.main' }}
        >
          {email ? email.charAt(0).toUpperCase() : '?'}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }} noWrap>
            {roleLabel}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap display="block">
            {email || t('common.user')}
          </Typography>
        </Box>
        <OptionsMenu />
      </Stack>
      <Divider />
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <AppMenuContent />
      </Box>
    </Drawer>
  );
}
